export default {
  selectedQuizTypeState: state => state.selectedQuizType
}
